module.exports = __webpack_public_path__ + "img/line-chart-down-05.62916a52.svg";